import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { OrderApiModel } from '../model/api-model/order/order.api.model';
import { OrderHttpService } from './order.http.service';

@Injectable({
  providedIn: 'root'
})
export class OrderVoucherItemHttpService {
  constructor(private http: HttpClient) {}

  add(cinemaId: string, orderId: string, items: { itemId: string; quantity: number }[]): Observable<OrderApiModel> {
    return this.http
      .patch<OrderApiModel>(`/cinema/${cinemaId}/order/${orderId}/voucheritem`, items)
      .pipe(tap((res) => OrderVoucherItemHttpService.cacheModify(orderId, res)));
  }

  update(cinemaId: string, orderId: string, items: { id: string; itemId: string; quantity: number }[]): Observable<OrderApiModel> {
    return this.http
      .patch<OrderApiModel>(`/cinema/${cinemaId}/order/${orderId}/voucheritem`, items)
      .pipe(tap((res) => OrderVoucherItemHttpService.cacheModify(orderId, res)));
  }

  delete(cinemaId: string, orderId: string, itemId: string, voucherNumber: string): Observable<OrderApiModel> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        voucherNumber: voucherNumber
      }
    };

    return this.http
      .delete<OrderApiModel>(`/cinema/${cinemaId}/order/${orderId}/item/${itemId}/voucher`, options)
      .pipe(tap((res) => OrderVoucherItemHttpService.cacheModify(orderId, res)));
  }

  private static cacheModify(key: string, responseData: Object): void {
    OrderHttpService.cacheModifier$.next((data: any[]) => {
      const oldCacheRow = data.find((p) => p.parameters[1] === key);

      if (!oldCacheRow) {
        return;
      }

      Object.assign(oldCacheRow.response, {
        ...responseData
      });

      return data;
    });
  }
}
